import { getDevicePrefs, onDevicePrefsChange } from "./devicePrefs";

// The wall's system on-screen keyboard (squeekboard on the Pi). Chromium raises
// it for every text box, even ones Kinmantle's own keyboard (ui/TouchKeyboard)
// has claimed, so inside Kinmantle it stays off unless ours is turned off in
// Display. Pages outside Kinmantle, such as Google's sign-in, have only the
// system keyboard, so it comes back on whenever the wall leaves the app.
// The switch is the wall's loopback helper (kiosk/files/kinmantle-photos).

const SWITCH = "http://127.0.0.1:47200/v1/keyboard";

function setSystemKeyboard(on: boolean) {
  try {
    // A beacon still goes out while the page is being left.
    navigator.sendBeacon(`${SWITCH}?on=${on ? 1 : 0}`);
  } catch {
    /* not the wall after all, or no helper: nothing to switch */
  }
}

export function installWallKeyboard() {
  if (!getDevicePrefs().wallComputer) return;
  let last: boolean | null = null;
  const sync = () => {
    const on = getDevicePrefs().touchKeyboard === "off";
    if (on !== last) setSystemKeyboard(on);
    last = on;
  };
  sync();
  onDevicePrefsChange(sync);
  window.addEventListener("pagehide", () => {
    setSystemKeyboard(true);
    last = true;
  });
  // Back from the page cache (no new page load).
  window.addEventListener("pageshow", (e) => {
    if (e.persisted) {
      last = null;
      sync();
    }
  });
}
